module.exports = __webpack_public_path__ + "img/MEDIA089.5ad97202.jpg";